export const CHECKOUT_URL =
  'https://professeur-de-danse-classique-pro.impultienda.ar/checkout'

export function trackCheckout() {
  const fbq = (
    window as Window & {
      fbq?: (...args: unknown[]) => void
    }
  ).fbq
  fbq?.('track', 'InitiateCheckout', {
    content_name: 'Professeur de Danse Classique Pro',
    value: 27,
    currency: 'EUR',
  })
}
